import React from 'react';
import { Box, Typography } from '@mui/material';

interface DevErrorBoundaryProps {
	children: React.ReactNode;
}

interface DevErrorBoundaryState {
	error: Error | null;
}

class DevErrorBoundary extends React.Component<DevErrorBoundaryProps, DevErrorBoundaryState> {
	state: DevErrorBoundaryState = { error: null };

	static getDerivedStateFromError(error: Error): DevErrorBoundaryState {
		return { error };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
		console.error('DevErrorBoundary caught:', error, errorInfo);
	}

	render() {
		const { error } = this.state;
		const { children } = this.props;

		if (!error) {
			return children;
		}

		return (
			<Box
				sx={{
					minHeight: '100vh',
					p: 3,
					bgcolor: '#111',
					color: '#ff8a80',
					fontFamily: 'monospace',
					overflow: 'auto',
				}}
			>
				<Typography variant='h5' sx={{ color: '#ff5252', mb: 2, fontFamily: 'inherit' }}>
					Runtime error (dev only)
				</Typography>
				<Typography sx={{ color: '#ffcdd2', mb: 2, fontFamily: 'inherit' }}>
					{error.message}
				</Typography>
				<Box component='pre' sx={{ m: 0, whiteSpace: 'pre-wrap', color: '#ffab91', fontSize: 13 }}>
					{error.stack}
				</Box>
			</Box>
		);
	}
}

export default DevErrorBoundary;
